<script lang="ts" module>
  import BaseCard, { type BaseCardProps } from './BaseCard.svelte';
  import CardHeader, { type CardHeaderProps } from './CardHeader.svelte';

  export type ContentCardProps = CardHeaderProps & BaseCardProps;
</script>

<script lang="ts">
  let { children, ...props }: ContentCardProps = $props();
</script>

<BaseCard {...props}>
  {#snippet header()}
    <CardHeader {...props}></CardHeader>
  {/snippet}
  {@render children?.()}
</BaseCard>
